import React, { useMemo } from 'react';
import { Row, Col } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import MetaTable from '@dex/bubl-dash/src/lib/components/MetaTable/MetaTable';
import ActivityPanel from '@dex/bubl-dash/src/lib/components/SinglePanels/ActivityPanel';

const SportSingleView: React.FC<any> = (props: any) => {

    const { data } = props;

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <Col
                className={'main'}
            >

                <Panel
                    heading={"Sport Details"}
                >

                    <MetaTable
                        data={data}
                        columnA={[
                            {
                                label: "Title",
                                key: "title",
                                format: "link",
                            }
                        ]}
                        columnB={[
                            {
                                label: "Status - League",
                                key: "statusLeague",
                                format: "titleCase"
                            },
                            {
                                label: "Status - Pickup",
                                key: "statusPickup",
                                format: "titleCase",
                            },
                            {
                                label: "Status - Camp",
                                key: "statusCamp",
                                format: "titleCase",
                            },
                            {
                                label: "Status - Global",
                                key: "statusGlobal",
                                format: "titleCase",
                            },
                        ]}
                        columnC={[
                            {
                                label: "Priority - League",
                                key: "priorityLeague",
                            },
                            {
                                label: "Priority - Pickup",
                                key: "priorityPickup",
                            },
                            {
                                label: "Priority - Camp",
                                key: "priorityCamp",
                            },
                            {
                                label: "Priority - Global",
                                key: "priorityGlobal",
                            },
                        ]}
                    />

                </Panel>

            </Col>

            <Col className={'side'}>

                <ActivityPanel parent={data} />

            </Col>

        </Row>

    ), [data]);

}

export default SportSingleView;
